export const servicesRoutes = {
  app: {
    getServices: '/app/services',
    getContractorServices: '/app/services/contractor-services',
  },
  internal: {
    getServices: '/internal/services',
  },
};
